export const isDateInPast = (receivedDate) => {
  const diff = new Date().getTime() - receivedDate.getTime();
  return diff > 0;
};
